export { default } from "../private-dining/gallery";